import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import { DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core'

interface ConfirmationDialogProps {
  title: string
  content: any
  isDialogOpen: boolean
  OkButtonText: string
  onOkButtonClick: () => void
  disableBackDropClick: boolean
  disableEscapeKeyDown: boolean
  CancelButtonText?: string
  onCancelButtonClick?: () => void
}

interface ConfirmationDialogState {
  isDialogOpen: boolean
}

export default class ConfirmationDialog extends React.Component<ConfirmationDialogProps, ConfirmationDialogState> {
  constructor(props: any) {
    super(props)
    this.state = { isDialogOpen: this.props.isDialogOpen }
  }

  componentWillReceiveProps(nextProps: any) {

    if (this.props !== nextProps) {
      this.setState({
        isDialogOpen: nextProps.isDialogOpen
      })
    }
  }

  render() {
    return (
      <Dialog
        open={this.state.isDialogOpen}
        disableBackdropClick={this.props.disableBackDropClick}
        disableEscapeKeyDown={this.props.disableEscapeKeyDown}
      >
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent>
          {this.props.content}
        </DialogContent>
        <DialogActions>
          {
            this.props.onCancelButtonClick ?
              <Button onClick={this.props.onCancelButtonClick} color="primary">
                {this.props.CancelButtonText}
              </Button>
              : ''
          }
          <Button onClick={this.props.onOkButtonClick} color="primary">
            {this.props.OkButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmationDialog.tsx